import React from 'react';
import styled from 'styled-components';

export const iconColors = {
  black: '#212121',
  blue_10: '#4d88ff',
  blue_20: '#2285EB',
  green: '#43a047',
  grey_5: '#e0e0e0',
  grey_10: '#bdbdbd',
  grey_20: '#9e9e9e',
  grey_30: '#757575',
  red: '#de3a3a',
  white: 'white',
  yellow: '#f6bd03',
};

const matchingIconPaths = (
  <>
    <path d="M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z" />
    <path d="M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z" />
  </>
);

export const Icons = {
  MatchingGradient: {
    defaultWidth: '28',
    defaultHeight: '28',
    defaultViewBox: '64 64 896 896',
    defaultColor: iconColors.black,
    data: (
      <>
        <defs>
          <linearGradient id="matching-gradient" x1="1" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#5eecfc" />
            <stop offset="1" stopColor="#0130f8" />
          </linearGradient>
        </defs>
        <g fill="url(#matching-gradient)">{matchingIconPaths}</g>
      </>
    ),
  },
  MatchingSolid: {
    defaultWidth: '28',
    defaultHeight: '28',
    defaultViewBox: '64 64 896 896',
    defaultColor: iconColors.white,
    data: <g fill="currentColor">{matchingIconPaths}</g>,
  },
  AddReminder: {
    defaultWidth: '19',
    defaultHeight: '22',
    defaultViewBox: '0 0 19 22',
    defaultColor: iconColors.black,
    data: (
      <path
        id="Union_89"
        data-name="Union 89"
        d="M-1259.392,5579.6c-.006-.01-.013-.02-.018-.03l-.008-.014a.887.887,0,0,1,.307-1.187.811.811,0,0,1,.42-.116.831.831,0,0,1,.724.433,1.118,1.118,0,0,0,.968.58,1.119,1.119,0,0,0,.969-.58.832.832,0,0,1,.724-.434.808.808,0,0,1,.419.118.885.885,0,0,1,.307,1.187A2.789,2.789,0,0,1-1257,5581,2.793,2.793,0,0,1-1259.392,5579.6Zm-4.857-2.1a.751.751,0,0,1-.749-.75.751.751,0,0,1,.749-.751h-.223c.777-.059,1.409-2.636,1.469-6l0-.5v-.5a6,6,0,0,1,4.913-5.9v1.525a4.65,4.65,0,0,0-3.574,4.537v.415h-.021c.008.293.013.579.013.846a18.551,18.551,0,0,1-.564,5.077h10.457a14.934,14.934,0,0,1-.522-3.5h1.412c.224,2.385.758,3.955,1.36,4h-.217a.752.752,0,0,1,.744.751.751.751,0,0,1-.749.75Zm12.251-9.252v-3.5h-3.5a.75.75,0,0,1-.749-.75.749.749,0,0,1,.749-.75h3.5v-3.5a.749.749,0,0,1,.748-.751.751.751,0,0,1,.751.751v3.5h3.5a.751.751,0,0,1,.751.75.751.751,0,0,1-.751.75h-3.5v3.5a.751.751,0,0,1-.751.75A.749.749,0,0,1-1252,5568.249Z"
        transform="translate(1264.998 -5558.999)"
        fill="currentColor"
      />
    ),
  },
  ArrowCircleDown: {
    defaultWidth: '24',
    defaultHeight: '24',
    defaultViewBox: '0 0 24 24',
    defaultColor: iconColors.black,
    data: (
      <path
        id="arrow-circle-down-2"
        data-name="arrow-circle-down"
        d="M24.563,12.563a12,12,0,1,1-12-12A12,12,0,0,1,24.563,12.563Zm-6.948-1.4-3.5,3.653V5.982A1.159,1.159,0,0,0,12.95,4.821h-.774a1.159,1.159,0,0,0-1.161,1.161v8.835l-3.5-3.653a1.163,1.163,0,0,0-1.66-.019l-.527.532a1.157,1.157,0,0,0,0,1.64l6.416,6.421a1.156,1.156,0,0,0,1.64,0L19.8,13.317a1.156,1.156,0,0,0,0-1.64l-.527-.532a1.163,1.163,0,0,0-1.66.019Z"
        transform="translate(-0.563 -0.563)"
      />
    ),
  },
  Attachment: {
    defaultWidth: '21',
    defaultHeight: '24',
    defaultViewBox: '0 0 21 24',
    defaultColor: iconColors.grey_30,
    data: (
      <path
        id="attachment_icon"
        d="M18.39,9.593,16.868,8.072,9.255,15.683a3.229,3.229,0,0,0,4.567,4.567l9.135-9.134A5.382,5.382,0,0,0,15.346,3.5l-9.591,9.59-.021.02A7.507,7.507,0,0,0,16.351,23.73l.019-.021h0l6.547-6.546-1.523-1.522-6.547,6.545-.02.02a5.353,5.353,0,0,1-7.572-7.57l.021-.02h0l9.592-9.59a3.229,3.229,0,0,1,4.568,4.567L12.3,18.727a1.076,1.076,0,0,1-1.523-1.522L18.39,9.593Z"
        transform="translate(-3.535 -1.928)"
        fill="currentColor"
      />
    ),
  },
  Check: {
    defaultWidth: '15',
    defaultHeight: '10',
    defaultViewBox: '0 0 15 10',
    defaultColor: iconColors.white,
    data: (
      <path
        id="Union_24"
        data-name="Union 24"
        d="M-1290.611,5214.9a1,1,0,0,1-.733-.293l-4.95-4.949a1,1,0,0,1,0-1.415,1,1,0,0,1,1.415,0l4.268,4.268,7.8-7.8a1,1,0,0,1,1.414,0h0a1,1,0,0,1,0,1.414l-8.485,8.485a.994.994,0,0,1-.707.293Z"
        transform="translate(1296.586 -5204.414)"
        fill="currentColor"
      />
    ),
  },
  Close: {
    defaultWidth: '9',
    defaultHeight: '9',
    defaultViewBox: '0 0 13 13',
    defaultColor: iconColors.grey_5,
    data: (
      <path
        id="icon_close"
        data-name="icon close"
        d="M19.589,18l4.8-4.8A1.124,1.124,0,0,0,22.8,11.616l-4.8,4.8-4.8-4.8A1.124,1.124,0,1,0,11.616,13.2l4.8,4.8-4.8,4.8A1.124,1.124,0,0,0,13.2,24.384l4.8-4.8,4.8,4.8A1.124,1.124,0,1,0,24.384,22.8Z"
        transform="translate(-11.285 -11.289)"
        fill="currentColor"
      />
    ),
  },
  DatePicker: {
    defaultWidth: '16',
    defaultHeight: '16',
    defaultViewBox: '0 0 16 16',
    defaultColor: iconColors.grey_20,
    data: (
      <path
        id="Icon_ionic-md-calendar"
        data-name="Icon ionic-md-calendar"
        d="M17.212,13.2H13.2v4.014h4.014ZM15.874,4.5V5.838H9.183V4.5H7.176V5.838h-1A1.677,1.677,0,0,0,4.5,7.511V18.885a1.677,1.677,0,0,0,1.673,1.673H18.885a1.677,1.677,0,0,0,1.673-1.673V7.511a1.677,1.677,0,0,0-1.673-1.673h-1V4.5Zm3.011,14.385H6.172V10.02H18.885Z"
        transform="translate(-4.5 -4.5)"
        fill="currentColor"
      />
    ),
  },
  File: {
    defaultWidth: '13',
    defaultHeight: '16',
    defaultViewBox: '0 0 13 16',
    defaultColor: iconColors.black,
    data: (
      <g id="Group_226" data-name="Group 226" transform="translate(0.11 0.012)">
        <path
          id="Union_78"
          data-name="Union 78"
          d="M-1681,4835.216a1,1,0,0,1-1-1v-14a1,1,0,0,1,1-1h6.724l1.5,1.5,2.276,2.276,1.5,1.5v.2a.749.749,0,0,1,0,.248v9.28a1,1,0,0,1-1,1Zm.5-1.5h10v-8h-4.105a.751.751,0,0,1-.75-.75v-4.251h-5.145Zm9.1-9.5-2.458-2.458v2.458Zm-6.854,7.5a.751.751,0,0,1-.75-.75.75.75,0,0,1,.75-.75h5.5a.749.749,0,0,1,.75.75.75.75,0,0,1-.75.75Zm0-2.5a.75.75,0,0,1-.75-.75.751.751,0,0,1,.75-.75h5.5a.75.75,0,0,1,.75.75.749.749,0,0,1-.75.75Z"
          transform="translate(1681.89 -4819.227)"
          fill="currentColor"
        />
      </g>
    ),
  },
  Filter: {
    defaultWidth: '18',
    defaultHeight: '15',
    defaultViewBox: '0 0 18 15',
    defaultColor: iconColors.black,
    data: (
      <>
        <path
          id="filter-2"
          data-name="filter"
          d="M-1254.139,5573.919a.749.749,0,0,1-.355-.1l-2.858-1.65a.76.76,0,0,1-.182-.147.748.748,0,0,1-.231-.542v-5.327l-6.414-6.415a.749.749,0,0,1-.335-.625.75.75,0,0,1,.75-.75h16.5a.75.75,0,0,1,.75.75.747.747,0,0,1-.229.54l-.009.009-6.512,6.512v7.005a.75.75,0,0,1-.75.75A.8.8,0,0,1-1254.139,5573.919Zm-.627-1.99v-6.049a.745.745,0,0,1,.143-.44.747.747,0,0,1,.109-.138l5.438-5.439h-12.858l5.454,5.454a.749.749,0,0,1,.214.619v5.127Z"
          transform="translate(1264.514 -5558.364)"
          fill="currentColor"
        />
      </>
    ),
  },
  FilterClear: {
    defaultWidth: '18',
    defaultHeight: '14',
    defaultViewBox: '0 0 18 14',
    defaultColor: iconColors.black,
    data: (
      <>
        <path
          id="Union_116"
          data-name="Union 116"
          d="M-1255.46,5572.276a.75.75,0,0,1,0-1.06l2.474-2.475-2.474-2.474a.752.752,0,0,1,0-1.062.749.749,0,0,1,1.062,0l2.474,2.474,2.475-2.474a.75.75,0,0,1,1.06,0,.75.75,0,0,1,0,1.062l-2.474,2.474,2.474,2.475a.748.748,0,0,1,0,1.06.746.746,0,0,1-.53.22.746.746,0,0,1-.53-.22l-2.475-2.474-2.474,2.474a.748.748,0,0,1-.531.22A.748.748,0,0,1-1255.46,5572.276Zm-2.632-.7a.742.742,0,0,1-.158-.46v-5.327l-6.414-6.415a.747.747,0,0,1-.336-.625.749.749,0,0,1,.75-.748h16.5a.749.749,0,0,1,.75.748.741.741,0,0,1-.229.54l-.008.009-5.472,5.474-.225-.225a1.987,1.987,0,0,0-1.109-.561l4.484-4.486h-12.857l5.454,5.456a.748.748,0,0,1,.214.62v4.66l-1.341,1.342Z"
          transform="translate(1264.999 -5558)"
          fill="#212121"
        />
      </>
    ),
  },
  FilterReset: {
    defaultWidth: '20',
    defaultHeight: '16',
    defaultViewBox: '0 0 20 16',
    defaultColor: iconColors.black,
    data: (
      <>
        <path
          id="Union_117"
          data-name="Union 117"
          d="M-1253.426,5572.565a1.091,1.091,0,0,0,.143-.1l1.03-.859a3.486,3.486,0,0,0,2.329.893,3.5,3.5,0,0,0,3.5-3.5,3.5,3.5,0,0,0-3.5-3.5,3.521,3.521,0,0,0-3.353,2.5h-1.546a5.015,5.015,0,0,1,4.9-4,5.006,5.006,0,0,1,5,5,5.006,5.006,0,0,1-5,5A4.971,4.971,0,0,1-1253.426,5572.565Zm-3.278-.107-1.133-.655a.687.687,0,0,1-.182-.147.739.739,0,0,1-.231-.54v-5.328l-6.414-6.414a.747.747,0,0,1-.336-.625.749.749,0,0,1,.75-.749h16.5a.749.749,0,0,1,.75.749.739.739,0,0,1-.229.54l-.008.009-3.21,3.21a6.7,6.7,0,0,0-3.016.9l3.9-3.906h-12.857l5.454,5.454a.752.752,0,0,1,.214.62v3.054c-.007.126-.011.251-.011.374,0,.222,0,.455,0,.694v.021c-.007.861-.015,1.839.063,2.742v0Zm2.426-1.812-1.792-1.793a.5.5,0,0,1,.353-.854h3.587a.5.5,0,0,1,.353.854l-1.792,1.793a.5.5,0,0,1-.354.146A.5.5,0,0,1-1254.278,5570.646Z"
          transform="translate(1265 -5558)"
          fill="#212121"
        />
      </>
    ),
  },
  HrReview: {
    defaultWidth: '16',
    defaultHeight: '16',
    defaultViewBox: '0 0 16 16',
    defaultColor: iconColors.green,
    data: (
      <path
        id="hr_review_icon"
        d="M16.558,8.56a8,8,0,1,1-8-8A8,8,0,0,1,16.558,8.56ZM7.635,12.8l5.934-5.934a.516.516,0,0,0,0-.73l-.73-.73a.516.516,0,0,0-.73,0L7.27,10.241,5.011,7.982a.516.516,0,0,0-.73,0l-.73.73a.516.516,0,0,0,0,.73L6.905,12.8a.516.516,0,0,0,.73,0Z"
        transform="translate(-0.563 -0.563)"
        fill="currentColor"
      />
    ),
  },
  Settings: {
    defaultWidth: '16',
    defaultHeight: '16',
    defaultViewBox: '0 0 16 16',
    defaultColor: iconColors.black,
    data: (
      <g id="settings_icon" transform="translate(-0.752 -0.751)">
        <path
          id="Union_92"
          data-name="Union 92"
          d="M-1259,5572v-.341a6.3,6.3,0,0,1-.588-.244l-.241.242a2,2,0,0,1-1.416.585,1.985,1.985,0,0,1-1.413-.585,1.988,1.988,0,0,1-.588-1.416,1.977,1.977,0,0,1,.588-1.413l.241-.242a5.957,5.957,0,0,1-.243-.586H-1263a2,2,0,0,1-2-2,2,2,0,0,1,2-2h.341a5.731,5.731,0,0,1,.243-.586l-.241-.241a1.982,1.982,0,0,1-.588-1.414,1.98,1.98,0,0,1,.588-1.414,1.981,1.981,0,0,1,1.413-.586,1.987,1.987,0,0,1,1.414.586l.242.242a5.756,5.756,0,0,1,.588-.245V5560a2,2,0,0,1,2-2,2,2,0,0,1,2,2v.341a5.659,5.659,0,0,1,.586.243l.242-.242a1.986,1.986,0,0,1,1.414-.586,1.987,1.987,0,0,1,1.414.586,1.981,1.981,0,0,1,.586,1.413,1.994,1.994,0,0,1-.586,1.416l-.242.241a5.647,5.647,0,0,1,.243.586h.343a2,2,0,0,1,2,2,2,2,0,0,1-2,2h-.343a6,6,0,0,1-.243.586l.242.242a1.982,1.982,0,0,1,.586,1.413,1.993,1.993,0,0,1-.586,1.416,1.991,1.991,0,0,1-1.414.585,1.991,1.991,0,0,1-1.414-.585l-.242-.242c-.19.09-.387.172-.586.244V5572a2,2,0,0,1-2,2A2,2,0,0,1-1259,5572Zm-.609-2.332a4.475,4.475,0,0,0,1.858.77v1.312a.751.751,0,0,0,.75.75.752.752,0,0,0,.75-.75v-1.312a4.5,4.5,0,0,0,1.858-.771l.929.929a.744.744,0,0,0,.53.219.747.747,0,0,0,.53-.219.753.753,0,0,0,.22-.532.743.743,0,0,0-.22-.529l-.929-.929a4.507,4.507,0,0,0,.769-1.856h1.312a.752.752,0,0,0,.751-.75.752.752,0,0,0-.751-.751h-1.312a4.5,4.5,0,0,0-.769-1.856l.929-.929a.747.747,0,0,0,.22-.53.746.746,0,0,0-.22-.53.747.747,0,0,0-.53-.22.742.742,0,0,0-.53.22l-.929.928a4.448,4.448,0,0,0-1.858-.77v-1.312a.751.751,0,0,0-.75-.75.75.75,0,0,0-.75.75v1.312a4.429,4.429,0,0,0-1.858.77l-.927-.928a.747.747,0,0,0-.53-.22.747.747,0,0,0-.531.22.751.751,0,0,0,0,1.061l.929.929a4.428,4.428,0,0,0-.769,1.856h-1.312a.751.751,0,0,0-.75.751.751.751,0,0,0,.75.75h1.312a4.5,4.5,0,0,0,.769,1.856l-.929.929a.751.751,0,0,0,0,1.061.747.747,0,0,0,.531.219.746.746,0,0,0,.53-.219l.926-.928ZM-1260,5566a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-1260,5566Zm1.5,0a1.5,1.5,0,0,0,1.5,1.5,1.5,1.5,0,0,0,1.5-1.5,1.5,1.5,0,0,0-1.5-1.5A1.5,1.5,0,0,0-1258.5,5566Z"
          transform="translate(1265.752 -5557.249)"
          fill="currentColor"
        />
      </g>
    ),
  },
  CandidatesGradient: {
    defaultWidth: '31',
    defaultHeight: '26',
    defaultViewBox: '0 0 31 26',
    defaultColor: iconColors.black,
    data: (
      <>
        <defs>
          <linearGradient
            id="candidates-gradient"
            x1="0.749"
            y1="0.116"
            x2="0.048"
            y2="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#5eecfc" />
            <stop offset="1" stopColor="#0130f8" />
          </linearGradient>
        </defs>
        <path
          id="Union_31"
          data-name="Union 31"
          d="M-3209,5770v-4.059a.029.029,0,0,0,0-.012c0-.018,0-.036,0-.054v-.063a.033.033,0,0,0,0-.013.463.463,0,0,0,0-.046v-.006a.034.034,0,0,1,0-.011l0-.046v-.025l0-.024,0-.028,0-.019,0-.019a2.994,2.994,0,0,0-2.15-2.463l-.042-.01a1.5,1.5,0,0,1-1.061-1.837,1.5,1.5,0,0,1,1.837-1.062h0A6.011,6.011,0,0,1-3206,5766v2a2,2,0,0,1-2,2Zm-26,0a2,2,0,0,1-2-2v-2a6.007,6.007,0,0,1,6-6h13a6.006,6.006,0,0,1,6,6v2a2,2,0,0,1-2,2Zm1-4v1h19v-1a3,3,0,0,0-3-3h-13A3,3,0,0,0-3234,5766Zm1-14.5a7.507,7.507,0,0,1,7.5-7.5,7.509,7.509,0,0,1,7.5,7.5,7.509,7.509,0,0,1-7.5,7.5A7.508,7.508,0,0,1-3233,5751.5Zm3,0a4.5,4.5,0,0,0,4.5,4.5,4.506,4.506,0,0,0,4.5-4.5,4.506,4.506,0,0,0-4.5-4.5A4.5,4.5,0,0,0-3230,5751.5Zm11.086,6.307a1.5,1.5,0,0,1,1.062-1.838l.014,0,0-.013A4.524,4.524,0,0,0-3214,5751.5a4.519,4.519,0,0,0-2.875-4.2.636.636,0,0,1-.075-.018,1.5,1.5,0,0,1-1.062-1.837,1.5,1.5,0,0,1,1.838-1.06,1.639,1.639,0,0,1,.169.056l.006-.016a7.52,7.52,0,0,1,5,7.071,7.494,7.494,0,0,1-6.079,7.368,1.522,1.522,0,0,1-.385.051A1.5,1.5,0,0,1-3218.912,5757.806Z"
          transform="translate(3237 -5744)"
          fill="url(#candidates-gradient)"
        />
      </>
    ),
  },
  CandidatesSolid: {
    defaultWidth: '31',
    defaultHeight: '26',
    defaultViewBox: '0 0 31 26',
    defaultColor: iconColors.black,
    data: (
      <>
        <path
          id="Union_31"
          data-name="Union 31"
          d="M-3209,5770v-4.059a.029.029,0,0,0,0-.012c0-.018,0-.036,0-.054v-.063a.033.033,0,0,0,0-.013.463.463,0,0,0,0-.046v-.006a.034.034,0,0,1,0-.011l0-.046v-.025l0-.024,0-.028,0-.019,0-.019a2.994,2.994,0,0,0-2.15-2.463l-.042-.01a1.5,1.5,0,0,1-1.061-1.837,1.5,1.5,0,0,1,1.837-1.062h0A6.011,6.011,0,0,1-3206,5766v2a2,2,0,0,1-2,2Zm-26,0a2,2,0,0,1-2-2v-2a6.007,6.007,0,0,1,6-6h13a6.006,6.006,0,0,1,6,6v2a2,2,0,0,1-2,2Zm1-4v1h19v-1a3,3,0,0,0-3-3h-13A3,3,0,0,0-3234,5766Zm1-14.5a7.507,7.507,0,0,1,7.5-7.5,7.509,7.509,0,0,1,7.5,7.5,7.509,7.509,0,0,1-7.5,7.5A7.508,7.508,0,0,1-3233,5751.5Zm3,0a4.5,4.5,0,0,0,4.5,4.5,4.506,4.506,0,0,0,4.5-4.5,4.506,4.506,0,0,0-4.5-4.5A4.5,4.5,0,0,0-3230,5751.5Zm11.086,6.307a1.5,1.5,0,0,1,1.062-1.838l.014,0,0-.013A4.524,4.524,0,0,0-3214,5751.5a4.519,4.519,0,0,0-2.875-4.2.636.636,0,0,1-.075-.018,1.5,1.5,0,0,1-1.062-1.837,1.5,1.5,0,0,1,1.838-1.06,1.639,1.639,0,0,1,.169.056l.006-.016a7.52,7.52,0,0,1,5,7.071,7.494,7.494,0,0,1-6.079,7.368,1.522,1.522,0,0,1-.385.051A1.5,1.5,0,0,1-3218.912,5757.806Z"
          transform="translate(3237 -5744)"
          fill="currentColor"
        />
      </>
    ),
  },
  ClientsGradient: {
    defaultWidth: '28',
    defaultHeight: '31',
    defaultViewBox: '0 0 28 31',
    defaultColor: iconColors.black,
    data: (
      <>
        <defs>
          <linearGradient
            id="clients-gradient"
            x1="0.909"
            y1="0.023"
            x2="0.006"
            y2="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#5eecfc" />
            <stop offset="1" stopColor="#0130f8" />
          </linearGradient>
        </defs>
        <path
          id="Union_9"
          data-name="Union 9"
          d="M8131.8-3329.044h-28v-2a3,3,0,0,1,2-2.829v-23.171a3,3,0,0,1,3-3h18a3,3,0,0,1,3,3v23.171a3,3,0,0,1,2,2.829v2Zm-5-3v-25h-18v25h6v-6a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v6ZM8120-3342a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1Zm-7,0a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1Zm7-7a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1Zm-7,0a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1Z"
          transform="translate(-8103.805 3360.044)"
          fill="url(#clients-gradient)"
        />
      </>
    ),
  },
  ClientsSolid: {
    defaultWidth: '28',
    defaultHeight: '31',
    defaultViewBox: '0 0 28 31',
    defaultColor: iconColors.black,
    data: (
      <>
        <path
          id="Union_9"
          data-name="Union 9"
          d="M8131.8-3329.044h-28v-2a3,3,0,0,1,2-2.829v-23.171a3,3,0,0,1,3-3h18a3,3,0,0,1,3,3v23.171a3,3,0,0,1,2,2.829v2Zm-5-3v-25h-18v25h6v-6a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v6ZM8120-3342a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1Zm-7,0a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1Zm7-7a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1Zm-7,0a1,1,0,0,1-1-1v-3a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1Z"
          transform="translate(-8103.805 3360.044)"
          fill="currentColor"
        />
      </>
    ),
  },
  Convert: {
    defaultWidth: '23',
    defaultHeight: '16',
    defaultViewBox: '0 0 23 16',
    defaultColor: iconColors.white,
    data: (
      <>
        <path
          id="Union_65"
          data-name="Union 65"
          d="M-1262.839,5577l2.066-2H-1251a2.977,2.977,0,0,0-.876-2.119,2.989,2.989,0,0,0-2.12-.88h-3.688a1.376,1.376,0,0,0,.322-.913v-.017a1.356,1.356,0,0,0-.4-.992l-.08-.077h3.592a5.257,5.257,0,0,1,5.253,5.249,1.755,1.755,0,0,1-1.752,1.752Zm1.839-12a4,4,0,0,1,4-4,4,4,0,0,1,4,4,4,4,0,0,1-4,4A4,4,0,0,1-1261,5565Zm2,0a2,2,0,0,0,2,2,2,2,0,0,0,2-2,2,2,0,0,0-2-2A2,2,0,0,0-1259,5565Z"
          transform="translate(1271.636 -5561.001)"
          fill="currentColor"
        />
        <path
          id="Icon_ionic-md-arrow-round-back"
          data-name="Icon ionic-md-arrow-round-back"
          d="M15.919,10.621H9.065l2.658-2.543a1.059,1.059,0,0,0,0-1.448.947.947,0,0,0-1.384,0L5.913,10.922a.976.976,0,0,0-.288.717v.013a.976.976,0,0,0,.288.717l4.423,4.292a.947.947,0,0,0,1.384,0,1.059,1.059,0,0,0,0-1.448L9.062,12.671h6.854a1,1,0,0,0,.98-1.025A.992.992,0,0,0,15.919,10.621Z"
          transform="translate(16.896 21.646) rotate(180)"
          fill="currentColor"
        />
      </>
    ),
  },
  Delete: {
    defaultWidth: '12',
    defaultHeight: '16',
    defaultViewBox: '0 0 12 16',
    defaultColor: iconColors.red,
    data: (
      <path
        id="Icon_material-delete-forever"
        data-name="Icon material-delete-forever"
        d="M8.389,18.722A1.783,1.783,0,0,0,10.167,20.5h7.111a1.783,1.783,0,0,0,1.778-1.778V8.056H8.389Zm2.187-6.329,1.253-1.253,1.893,1.884,1.884-1.884,1.253,1.253-1.884,1.884,1.884,1.884-1.253,1.253-1.884-1.884-1.884,1.884-1.253-1.253,1.884-1.884Zm6.258-7L15.944,4.5H11.5l-.889.889H7.5V7.167H19.944V5.389Z"
        transform="translate(-7.5 -4.5)"
        fill="currentColor"
      />
    ),
  },
  DictionariesGradient: {
    defaultWidth: '22',
    defaultHeight: '27',
    defaultViewBox: '0 0 22 27',
    defaultColor: iconColors.black,
    data: (
      <>
        <defs>
          <linearGradient
            id="dictionaries-gradient"
            x1="0.941"
            y1="0.072"
            x2="0.043"
            y2="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#5eecfc" />
            <stop offset="1" stopColor="#0130f8" />
          </linearGradient>
        </defs>
        <path
          id="Union_15"
          data-name="Union 15"
          d="M-3181,4383.5h-16a4,4,0,0,1-4-4V4361a4,4,0,0,1,4-4h17a1,1,0,0,1,1,1v19h-.037c-.4.046-.712.812-.712,1.748,0,.965.335,1.75.748,1.75h0v2a1,1,0,0,1-1,1Zm-17-5.5v1.5a1,1,0,0,0,1,1h14.515a5.86,5.86,0,0,1-.265-1.751,5.838,5.838,0,0,1,.263-1.748H-3197A1,1,0,0,0-3198,4378Zm0-17v13.126a3.976,3.976,0,0,1,1-.126h15v-14h-15A1,1,0,0,0-3198,4361Z"
          transform="translate(3201 -4357)"
          fill="url(#dictionaries-gradient)"
        />
      </>
    ),
  },
  DictionariesSolid: {
    defaultWidth: '22',
    defaultHeight: '27',
    defaultViewBox: '0 0 22 27',
    defaultColor: iconColors.white,
    data: (
      <>
        <path
          id="Union_15"
          data-name="Union 15"
          d="M-3181,4383.5h-16a4,4,0,0,1-4-4V4361a4,4,0,0,1,4-4h17a1,1,0,0,1,1,1v19h-.037c-.4.046-.712.812-.712,1.748,0,.965.335,1.75.748,1.75h0v2a1,1,0,0,1-1,1Zm-17-5.5v1.5a1,1,0,0,0,1,1h14.515a5.86,5.86,0,0,1-.265-1.751,5.838,5.838,0,0,1,.263-1.748H-3197A1,1,0,0,0-3198,4378Zm0-17v13.126a3.976,3.976,0,0,1,1-.126h15v-14h-15A1,1,0,0,0-3198,4361Z"
          transform="translate(3201 -4357)"
          fill="currentColor"
        />
      </>
    ),
  },
  Dots: {
    defaultWidth: '3',
    defaultHeight: '17',
    defaultViewBox: '0 0 3 17',
    defaultColor: iconColors.black,
    data: (
      <>
        <circle id="Ellipse_6" data-name="Ellipse 6" cx="1.5" cy="1.5" r="1.5" fill="currentColor" />
        <circle
          id="Ellipse_7"
          data-name="Ellipse 7"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 7)"
          fill="currentColor"
        />
        <circle
          id="Ellipse_8"
          data-name="Ellipse 8"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 14)"
          fill="currentColor"
        />
      </>
    ),
  },
  Edit: {
    defaultWidth: '16',
    defaultHeight: '16',
    defaultViewBox: '0 0 16 16',
    defaultColor: iconColors.black,
    data: (
      <path
        id="Union_75"
        data-name="Union 75"
        d="M-1265,5574v-3.333l9.829-9.83,3.334,3.333-9.83,9.83Zm6.617-.5,1.918-2h6.646v2Zm4.163-13.612,1.627-1.627a.884.884,0,0,1,1.253,0l2.079,2.08a.883.883,0,0,1,0,1.252l-1.626,1.627Z"
        transform="translate(1265 -5558)"
        fill="currentColor"
      />
    ),
  },
  EmailsGradient: {
    defaultWidth: '26',
    defaultHeight: '21',
    defaultViewBox: '0 0 26 21',
    defaultColor: iconColors.black,
    data: (
      <>
        <defs>
          <linearGradient
            id="emails-gradient"
            x1="0.941"
            y1="0.072"
            x2="0.043"
            y2="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#5eecfc" />
            <stop offset="1" stopColor="#0130f8" />
          </linearGradient>
        </defs>
        <path
          id="Union_13"
          data-name="Union 13"
          d="M-3198,4377.5a3,3,0,0,1-3-3V4360a3,3,0,0,1,3-3h20a3,3,0,0,1,3,3v14.5a3,3,0,0,1-3,3Zm0-3h20v-11.6l-9.141,5.278a1.5,1.5,0,0,1-.542.187,1.5,1.5,0,0,1-1.074-.166l-9.241-5.335Zm10.031-9.306,8.993-5.193h-17.989Z"
          transform="translate(3201 -4357)"
          fill="url(#emails-gradient)"
        />
      </>
    ),
  },
  EmailsSolid: {
    defaultWidth: '26',
    defaultHeight: '21',
    defaultViewBox: '0 0 26 21',
    defaultColor: iconColors.white,
    data: (
      <>
        <path
          id="Union_13"
          data-name="Union 13"
          d="M-3198,4377.5a3,3,0,0,1-3-3V4360a3,3,0,0,1,3-3h20a3,3,0,0,1,3,3v14.5a3,3,0,0,1-3,3Zm0-3h20v-11.6l-9.141,5.278a1.5,1.5,0,0,1-.542.187,1.5,1.5,0,0,1-1.074-.166l-9.241-5.335Zm10.031-9.306,8.993-5.193h-17.989Z"
          transform="translate(3201 -4357)"
          fill="currentColor"
        />
      </>
    ),
  },
  Lock: {
    defaultWidth: '16',
    defaultHeight: '18',
    defaultViewBox: '0 0 16 18',
    defaultColor: iconColors.white,
    data: (
      <path
        id="lock_icon"
        d="M13.9,7.783h-.834v-2.5a5.281,5.281,0,0,0-10.562,0v2.5H1.668A1.668,1.668,0,0,0,0,9.45v6.671a1.668,1.668,0,0,0,1.668,1.668H13.9a1.668,1.668,0,0,0,1.668-1.668V9.45A1.668,1.668,0,0,0,13.9,7.783Zm-3.613,0h-5v-2.5a2.5,2.5,0,0,1,5,0Z"
        fill="currentColor"
      />
    ),
  },
  Logo: {
    defaultWidth: '52',
    defaultHeight: '50',
    defaultViewBox: '0 0 52 50',
    defaultColor: iconColors.white,
    data: (
      <>
        <defs>
          <linearGradient
            id="logo-gradient"
            x1="0.181"
            y1="1.013"
            x2="1.018"
            y2="-0.281"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#0130f8" />
            <stop offset="0.774" stopColor="#5eecfc" />
            <stop offset="1" stopColor="#fff" />
          </linearGradient>
        </defs>
        <path
          id="Union_93"
          data-name="Union 93"
          d="M22,49.473a.93.93,0,0,1-.482-.256c-.118-.132-.122-.147-.1-.392s.02-.26-.1-.361l-.125-.1.129-.31c.1-.248.122-.33.09-.407-.051-.128-.176-.206-.392-.237a1.187,1.187,0,0,1-.561-.287.418.418,0,0,1-.086-.182,1.526,1.526,0,0,0-.161-.337c-.129-.213-.447-.912-.851-1.87A10.042,10.042,0,0,0,18.23,42.87c-.561-.749-.659-.912-.706-1.206a4.618,4.618,0,0,1-.055-.6l-.008-.33.733-1.4a10.556,10.556,0,0,0,.992-2.134,6.514,6.514,0,0,0,.149-1.032,3.666,3.666,0,0,0-.329-.671,3.053,3.053,0,0,0-1.141-1.269,2.612,2.612,0,0,1-.733-.7,5.965,5.965,0,0,1-.588-.811,2.92,2.92,0,0,1-.318-.927,3.452,3.452,0,0,0-.1-.489,4.3,4.3,0,0,1-.106-.574V30.72a3.792,3.792,0,0,1-.645.094c-2.484.166-4.123,1.054-4.574,4.334s3.779,5.524,3.2,8c-1.778-3.811-4.419-3.2-4.634-6.7-.859.956-.73,3.335.363,5.071C8.12,40.48,7.476,39.439,7.662,37.123c-1.389.977-2.931,4.5.977,5.248s4.569,3.994,2.937,6.012-5.9,1.041-5.254-.986c1.9,2.919,6.395-1.759,1.175-2.668s-4.123-5.205-3.938-6.8c-1.881,1.047-3.89-.007-3.513-1.712.85,1.713,2.727,1.23,2.834-.385A7.149,7.149,0,0,1,5.066,31.1c3.071-2.983,9.24-2.541,10.58-2.375a1.73,1.73,0,0,1,.724.264c.068-.012.1-.086.182-.245a8.541,8.541,0,0,1,2.341-2.413,29.676,29.676,0,0,1,5.3-3.173c.741-.373,1.4-.718,1.47-.772a1.069,1.069,0,0,0,.22-.3,3.534,3.534,0,0,1,.494-.632c.643-.687.706-.78.745-1.09l0-.03a1.669,1.669,0,0,1-.185.093,3.634,3.634,0,0,1-2.747.1,2.475,2.475,0,0,0-2.2.081c.973-1.129,1.029-.777,3.128-.954-.861-.608-1.979-.314-3.078-.083.29-1.333,3.391-.8,4.5-1.334a.482.482,0,0,1-.238,0,4.192,4.192,0,0,1-1.686-.228,2.732,2.732,0,0,0-2.9.356c-1.688,1.531-3.24.6-4.58,1.373.773-1.294,3.364-.647,4.052-2.228-1.4.527-1.961-.12-2.107-.555a2.4,2.4,0,0,0,2.65-.647c-1.051.258-1.638.1-1.753-.209,1.284.179,1.786-.97,3.41-1.421-.844-.115-1.1-.816-1.029-.994a1.4,1.4,0,0,0,1.782.138c-.455.067-.579-.116-.6-.273.949.185.816-.718,2.874-1.051a1.8,1.8,0,0,0-1.555-.322,1.266,1.266,0,0,1-1.356-.374c1.277.259,1.464-.421,2.458-.473-1.628-.362-2.323-2.666-4.718-.741a3.631,3.631,0,0,1,3.963-2.227c.525.014.9.027.986-.189a1.274,1.274,0,0,1-1.418-.7,2.493,2.493,0,0,0,2.052.178,1.36,1.36,0,0,1-1.464-.513,2.9,2.9,0,0,0,2.752-.529c-1,.229-1.356.621-2.2.128,1.164.246,2.334-1.389,3.624-1.639a1.581,1.581,0,0,0-.42-.037,2.854,2.854,0,0,1-.465-.027c.832-.416,1.092-.16,1.825-.507-.077-.14-.351-.185-.6-.225a8.447,8.447,0,0,1,4.653.288c.44.158.862.333,1.242.515.218.01.4-.014.464-.113a1.465,1.465,0,0,1,.961-.632c.125,0,.153-.015.2-.12a1.754,1.754,0,0,1,.949-.733.534.534,0,0,0,.282-.229,2.38,2.38,0,0,1,.772-.609,2.278,2.278,0,0,0,.478-.384,4.078,4.078,0,0,1,.557-.458,3.181,3.181,0,0,0,.451-.357c.1-.1.38-.345.627-.543s.494-.408.549-.466A3.473,3.473,0,0,1,42.614,0c0,.031-.741.9-1.043,1.222a5.478,5.478,0,0,0-.369.442,5.533,5.533,0,0,1-.447.527,4.406,4.406,0,0,0-.474.6,3,3,0,0,1-.416.5,1.621,1.621,0,0,0-.376.493,2.17,2.17,0,0,1-.623.784c-.106.074-.172.151-.172.2a1.98,1.98,0,0,1-.357.687,1.636,1.636,0,0,1-.294.271.535.535,0,0,0-.172.151c0,.023.071.039.157.039.157,0-.169.043-.208.19a1.81,1.81,0,0,0-.1.693,1.218,1.218,0,0,0,.245.568c-.02.016.02.074.086.124s.094.093.067.093-.027.031.027.1a2.221,2.221,0,0,1,.3.877.9.9,0,0,0,.278.609.778.778,0,0,1,.27.527,9.9,9.9,0,0,0,1.451,2.25,7.275,7.275,0,0,1,.9,1.354,3.267,3.267,0,0,1,.255.788,1.548,1.548,0,0,1-.157.275.778.778,0,0,0-.157.365.441.441,0,0,1-.2.372c-.055.035-.165.116-.243.179l-.145.112-.118-.085-.118-.086.024.128c.016.089.008.147-.028.174a1.48,1.48,0,0,1-.67.151,1.273,1.273,0,0,1-.553-.5c-.251-.349-.337-.415-.655-.5a4.679,4.679,0,0,1-1.2-.559,5.392,5.392,0,0,0-.71-.345c-.188-.07-.608-.252-.929-.4s-.588-.272-.592-.268a2.044,2.044,0,0,0,.02.264c.016.14.063.539.1.892s.1.776.141.946a9.386,9.386,0,0,0,1.462,2.657c.09.093.463.411.827.7.721.574.933.784,1.082,1.074a2.171,2.171,0,0,0,.161.268c.071.078.071.078.333-.167A11.35,11.35,0,0,1,40.79,18.6a6.478,6.478,0,0,0,1.745-1.427c.388-.485.373-.473.521-.473a4.989,4.989,0,0,1,1.157.361.838.838,0,0,0,.549.1,1.224,1.224,0,0,1,.768.128,2.193,2.193,0,0,0,.318.108.45.45,0,0,1,.176.116c.149.14.286.178.823.233a3.064,3.064,0,0,1,.627.124c.349.136,1.219.551,1.521.725.455.26.474.287.541.655a2.076,2.076,0,0,0,.114.431,1.873,1.873,0,0,0,.761.628c.188.066.243.1.274.194s.129.155.62.388c.318.155.584.283.592.287a1.416,1.416,0,0,1-.075.233,1.331,1.331,0,0,1-.663.675,5.009,5.009,0,0,1-1.674.431c-.145,0-.161-.012-.22-.147a1.424,1.424,0,0,1-.086-.26.264.264,0,0,0-.137-.182c-.165-.093-.18-.209-.063-.578a2.684,2.684,0,0,0,.1-.388c0-.1-.247-.287-.572-.439-.341-.163-.643-.469-.643-.659,0-.167-.027-.194-.274-.252-.118-.031-.482-.155-.812-.279s-.616-.229-.635-.229c-.118,0-.122.59-.012,1.327.043.283.1.671.125.865a16.255,16.255,0,0,0,.392,1.8,6.192,6.192,0,0,1,.165.776,1.377,1.377,0,0,1-.2.718.643.643,0,0,0-.118.2.322.322,0,0,1-.133.159c-.071.031-.1.093-.137.287-.028.132-.059.287-.071.342-.027.139-.3.376-.67.593-.251.148-.341.221-.4.345a.4.4,0,0,1-.192.194,1.09,1.09,0,0,0-.337.314,3.394,3.394,0,0,1-.674.695c-.145.089-.2.07-.416-.147a2.929,2.929,0,0,1-.49-1.878c.043-.38.106-.543.223-.586a1.112,1.112,0,0,0,.3-.252c.153-.163.227-.217.341-.236.137-.02.157-.008.357.2.314.333.337.291.239-.388a.356.356,0,0,1,.078-.3.654.654,0,0,0,.1-.2,1.329,1.329,0,0,1,.176-.3c.47-.671.482-.733.278-1.431a12.058,12.058,0,0,1-.47-2.444l0-.407-.4.388a18.757,18.757,0,0,0-1.686,2.036A22.263,22.263,0,0,0,40.3,25.216l-.529,1-.255.12a1.119,1.119,0,0,1-.584.124l-.329.008-.22.21c-.122.116-.4.357-.631.535-.788.621-2.011,1.684-2.7,2.343a4.233,4.233,0,0,1-1.388,1.071,13.16,13.16,0,0,1-2.713.776c-.388.086-.89.213-1.117.283s-.51.155-.627.178a8.766,8.766,0,0,0-1,.318,1.835,1.835,0,0,1-.831.085l-.6,0-.137.411c-.075.229-.145.481-.161.562A7.45,7.45,0,0,1,25.123,35.4a8.052,8.052,0,0,0-.945,1.49c-.192.384-.416.846-.49,1.02s-.184.427-.251.551a.786.786,0,0,0-.09.586,5.511,5.511,0,0,0,.094.694c.043.182.094.427.118.543a7.3,7.3,0,0,0,.639,1.532,7.86,7.86,0,0,0,1.274,1.513c.337.341.749.772.914.95a2.775,2.775,0,0,0,.843.652,7.632,7.632,0,0,1,.694.446c.141.117.149.132.106.24s-.035.124.071.217a2.435,2.435,0,0,1,.557.8,2.959,2.959,0,0,1-.776.481,2.355,2.355,0,0,1-1.008.07c-.627-.081-.741-.159-.812-.574-.043-.264-.059-.295-.157-.333-.129-.047-.141-.136-.051-.481.063-.241.039-.392-.067-.458a1.332,1.332,0,0,0-.325-.058.821.821,0,0,1-.745-.388,2.054,2.054,0,0,0-.216-.318c-.1-.12-.937-1.4-1.215-1.862a13.038,13.038,0,0,0-1.47-1.676,8.145,8.145,0,0,1-.627-.679,4.038,4.038,0,0,1-.267-1.02.742.742,0,0,0-.016-.182c-.008,0-.149.205-.314.454s-.349.528-.408.613c-.282.384-.282.388-.278,1.242a4.679,4.679,0,0,0,.1,1.241,5.457,5.457,0,0,0,.7,1.85,15.855,15.855,0,0,0,.917,1.307,3.945,3.945,0,0,1,.325.473,3.166,3.166,0,0,0,.882,1c.239.19.5.419.584.5.145.151.149.159.1.291s-.043.143.075.291a3.126,3.126,0,0,1,.38.737c.024.078-.008.1-.3.241a1.963,1.963,0,0,1-.867.218A2.617,2.617,0,0,1,22,49.473Zm4.538-31.278a.971.971,0,0,0,.131-.02q.032-.021.061-.044A1.86,1.86,0,0,1,26.536,18.195Z"
          transform="translate(0 0)"
          fill="url(#logo-gradient)"
        />
      </>
    ),
  },
  Plus: {
    defaultWidth: '16',
    defaultHeight: '16',
    defaultViewBox: '0 0 16 16',
    defaultColor: iconColors.black,
    data: (
      <>
        <rect
          id="Rectangle_301"
          data-name="Rectangle 301"
          width="2"
          height="16"
          rx="1"
          transform="translate(7)"
          fill="currentColor"
        />
        <rect
          id="Rectangle_302"
          data-name="Rectangle 302"
          width="2"
          height="16"
          rx="1"
          transform="translate(16 7) rotate(90)"
          fill="currentColor"
        />
      </>
    ),
  },
  PlusSmall: {
    defaultWidth: '18',
    defaultHeight: '18',
    defaultViewBox: '0 0 18 18',
    defaultColor: iconColors.black,
    data: (
      <path
        id="Subtraction_7"
        data-name="Subtraction 7"
        d="M5021-4303h-18v-18h18v18Zm-10-8v4h2v-4h4v-2h-4v-4h-2v4h-4v2Z"
        transform="translate(-5003 4321)"
        fill="currentColor"
      />
    ),
  },
  PriorityLow: {
    defaultWidth: '17',
    defaultHeight: '10',
    defaultViewBox: '0 0 17 10',
    defaultColor: iconColors.blue_10,
    data: (
      <path
        id="Icon_ionic-ios-arrow-down"
        data-name="Icon ionic-ios-arrow-down"
        d="M14.873,18.182l6.566-6.571a1.236,1.236,0,0,1,1.753,0,1.251,1.251,0,0,1,0,1.758l-7.44,7.445a1.239,1.239,0,0,1-1.711.036L6.549,13.374A1.241,1.241,0,1,1,8.3,11.616Z"
        transform="translate(-6.188 -11.246)"
        fill="currentColor"
      />
    ),
  },
  PriorityMedium: {
    defaultWidth: '17',
    defaultHeight: '9',
    defaultViewBox: '0 0 17 9',
    defaultColor: iconColors.yellow,
    data: (
      <>
        <rect id="Rectangle_800" data-name="Rectangle 800" width="17" height="2.5" rx="1" fill="#f6bd03" />
        <rect
          id="Rectangle_801"
          data-name="Rectangle 801"
          width="17"
          height="2.5"
          rx="1"
          transform="translate(0 6)"
          fill="currentColor"
        />
      </>
    ),
  },
  PriorityHigh: {
    defaultWidth: '17',
    defaultHeight: '10',
    defaultViewBox: '0 0 17 10',
    defaultColor: iconColors.red,
    data: (
      <path
        id="Icon_ionic-ios-arrow-down"
        data-name="Icon ionic-ios-arrow-down"
        d="M14.873,14.239l6.566,6.571a1.236,1.236,0,0,0,1.753,0,1.251,1.251,0,0,0,0-1.758l-7.44-7.445a1.239,1.239,0,0,0-1.711-.036L6.549,19.047A1.241,1.241,0,1,0,8.3,20.805Z"
        transform="translate(-6.188 -11.246)"
        fill="currentColor"
      />
    ),
  },
  ProjectsGradient: {
    defaultWidth: '29',
    defaultHeight: '26',
    defaultViewBox: '0 0 29 26',
    defaultColor: iconColors.black,
    data: (
      <>
        <defs>
          <linearGradient
            id="projects-gradient"
            x1="0.762"
            y1="0.229"
            x2="0.086"
            y2="1.14"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#5eecfc" />
            <stop offset="1" stopColor="#0130f8" />
          </linearGradient>
        </defs>
        <path
          id="Union_6"
          data-name="Union 6"
          d="M10,26H4a4,4,0,0,1-4-4V10A4,4,0,0,1,4,6H7V4a4,4,0,0,1,4-4h7a4,4,0,0,1,4,4V6h3a4,4,0,0,1,4,4V22a4,4,0,0,1-4,4H10Zm15-3a1,1,0,0,0,1-1V10a1,1,0,0,0-1-1H22V23Zm-6,0V9H10V23ZM3,10V22a1,1,0,0,0,1,1H7V9H4A1,1,0,0,0,3,10ZM19,6V4a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V6Z"
          fill="url(#projects-gradient)"
        />
      </>
    ),
  },
  ProjectsSolid: {
    defaultWidth: '29',
    defaultHeight: '26',
    defaultViewBox: '0 0 29 26',
    defaultColor: iconColors.black,
    data: (
      <path
        id="Union_6"
        data-name="Union 6"
        d="M10,26H4a4,4,0,0,1-4-4V10A4,4,0,0,1,4,6H7V4a4,4,0,0,1,4-4h7a4,4,0,0,1,4,4V6h3a4,4,0,0,1,4,4V22a4,4,0,0,1-4,4H10Zm15-3a1,1,0,0,0,1-1V10a1,1,0,0,0-1-1H22V23Zm-6,0V9H10V23ZM3,10V22a1,1,0,0,0,1,1H7V9H4A1,1,0,0,0,3,10ZM19,6V4a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V6Z"
        fill="currentColor"
      />
    ),
  },
  RecruitmentsGradient: {
    defaultWidth: '28',
    defaultHeight: '22',
    defaultViewBox: '0 0 28 22',
    defaultColor: iconColors.black,
    data: (
      <>
        <defs>
          <linearGradient
            id="recruitment-gradient"
            x1="0.953"
            y1="0.05"
            x2="0"
            y2="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#5eecfc" />
            <stop offset="1" stopColor="#0130f8" />
          </linearGradient>
        </defs>
        <path
          id="id-card-regular"
          d="M17.941,47.211h4.68a1.17,1.17,0,1,0,0-2.34h-4.68a1.17,1.17,0,1,0,0,2.34Zm-7.8-1.17a3.12,3.12,0,1,0-3.12-3.12A3.12,3.12,0,0,0,10.141,46.041ZM24.961,32H3.12A3.12,3.12,0,0,0,0,35.12v15.6a3.12,3.12,0,0,0,3.12,3.12H24.961a3.12,3.12,0,0,0,3.12-3.12V35.12A3.122,3.122,0,0,0,24.961,32Zm.78,18.721a.781.781,0,0,1-.78.78H15.6a3.9,3.9,0,0,0-3.9-3.9H8.58a3.9,3.9,0,0,0-3.9,3.9H3.12a.781.781,0,0,1-.78-.78V38.24h23.4Zm-7.8-7.41h4.68a1.17,1.17,0,1,0,0-2.34h-4.68a1.17,1.17,0,1,0,0,2.34Z"
          transform="translate(0 -32)"
          fill="url(#recruitment-gradient)"
        />
      </>
    ),
  },
  RecruitmentsSolid: {
    defaultWidth: '28',
    defaultHeight: '22',
    defaultViewBox: '0 0 28 22',
    defaultColor: iconColors.white,
    data: (
      <path
        id="id-card-regular"
        d="M17.941,47.211h4.68a1.17,1.17,0,1,0,0-2.34h-4.68a1.17,1.17,0,1,0,0,2.34Zm-7.8-1.17a3.12,3.12,0,1,0-3.12-3.12A3.12,3.12,0,0,0,10.141,46.041ZM24.961,32H3.12A3.12,3.12,0,0,0,0,35.12v15.6a3.12,3.12,0,0,0,3.12,3.12H24.961a3.12,3.12,0,0,0,3.12-3.12V35.12A3.122,3.122,0,0,0,24.961,32Zm.78,18.721a.781.781,0,0,1-.78.78H15.6a3.9,3.9,0,0,0-3.9-3.9H8.58a3.9,3.9,0,0,0-3.9,3.9H3.12a.781.781,0,0,1-.78-.78V38.24h23.4Zm-7.8-7.41h4.68a1.17,1.17,0,1,0,0-2.34h-4.68a1.17,1.17,0,1,0,0,2.34Z"
        transform="translate(0 -32)"
        fill="currentColor"
      />
    ),
  },
  RemindersGradient: {
    defaultWidth: '24',
    defaultHeight: '26',
    defaultViewBox: '0 0 24 26',
    defaultColor: iconColors.black,
    data: (
      <>
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="0.767"
            y1="0.101"
            x2="0.027"
            y2="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#5eecfc" />
            <stop offset="1" stopColor="#0130f8" />
          </linearGradient>
        </defs>
        <path
          id="Union_20"
          data-name="Union 20"
          d="M-3193.285,4380.572c-.015-.023-.031-.047-.045-.071a1.5,1.5,0,0,1,.549-2.049,1.5,1.5,0,0,1,2.049.549l.019.032A2.007,2.007,0,0,0-3189,4380a2.008,2.008,0,0,0,1.732-1,1.5,1.5,0,0,1,2.048-.549,1.5,1.5,0,0,1,.55,2.049c-.012.02-.023.04-.036.058A5.02,5.02,0,0,1-3189,4383,5.019,5.019,0,0,1-3193.285,4380.572Zm-6.217-4.57a1.5,1.5,0,0,1-1.5-1.5,1.5,1.5,0,0,1,1.5-1.5h.1v-.014c.785-.226,1.4-3.075,1.4-6.485,0-.173,0-.337,0-.5a9.018,9.018,0,0,1,9.006-9,9.009,9.009,0,0,1,9,9h0v.122c0,.118,0,.241,0,.378,0,3.414.615,6.263,1.4,6.485V4373h.1a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5Zm4.5-9a20.144,20.144,0,0,1-.727,6h13.453a20.146,20.146,0,0,1-.727-6c0-.372.006-.708.016-1H-3183a5.959,5.959,0,0,0-1.759-4.24A5.959,5.959,0,0,0-3189,4360a6.006,6.006,0,0,0-6,6h-.015C-3195.006,4366.3-3195,4366.631-3195,4367Z"
          transform="translate(3200.999 -4357)"
          fill="url(#linear-gradient)"
        />
      </>
    ),
  },
  RemidnersSolid: {
    defaultWidth: '24',
    defaultHeight: '26',
    defaultViewBox: '0 0 24 26',
    defaultColor: iconColors.black,
    data: (
      <path
        id="Union_20"
        data-name="Union 20"
        d="M-3193.285,4380.572c-.015-.023-.031-.047-.045-.071a1.5,1.5,0,0,1,.549-2.049,1.5,1.5,0,0,1,2.049.549l.019.032A2.007,2.007,0,0,0-3189,4380a2.008,2.008,0,0,0,1.732-1,1.5,1.5,0,0,1,2.048-.549,1.5,1.5,0,0,1,.55,2.049c-.012.02-.023.04-.036.058A5.02,5.02,0,0,1-3189,4383,5.019,5.019,0,0,1-3193.285,4380.572Zm-6.217-4.57a1.5,1.5,0,0,1-1.5-1.5,1.5,1.5,0,0,1,1.5-1.5h.1v-.014c.785-.226,1.4-3.075,1.4-6.485,0-.173,0-.337,0-.5a9.018,9.018,0,0,1,9.006-9,9.009,9.009,0,0,1,9,9h0v.122c0,.118,0,.241,0,.378,0,3.414.615,6.263,1.4,6.485V4373h.1a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5Zm4.5-9a20.144,20.144,0,0,1-.727,6h13.453a20.146,20.146,0,0,1-.727-6c0-.372.006-.708.016-1H-3183a5.959,5.959,0,0,0-1.759-4.24A5.959,5.959,0,0,0-3189,4360a6.006,6.006,0,0,0-6,6h-.015C-3195.006,4366.3-3195,4366.631-3195,4367Z"
        transform="translate(3200.999 -4357)"
        fill="currentColor"
      />
    ),
  },
  Restore: {
    defaultWidth: '19',
    defaultHeight: '16',
    defaultViewBox: '0 0 19 16',
    defaultColor: iconColors.black,
    data: (
      <path
        id="restore_filters_icon"
        d="M12.167,4.5a8,8,0,0,0-8,8H1.5l3.458,3.458.062.124L8.611,12.5H5.944a6.252,6.252,0,1,1,1.831,4.391L6.513,18.153A8,8,0,1,0,12.167,4.5Z"
        transform="translate(-1.5 -4.5)"
        fill="currentColor"
      />
    ),
  },
  Save: {
    defaultWidth: '16',
    defaultHeight: '16',
    defaultViewBox: '0 0 16 16',
    defaultColor: iconColors.white,
    data: (
      <>
        <rect
          id="Rectangle_816"
          data-name="Rectangle 816"
          width="8"
          height="1.5"
          rx="0.75"
          transform="translate(3.999 8)"
          fill="currentColor"
        />
        <rect
          id="Rectangle_817"
          data-name="Rectangle 817"
          width="6.965"
          height="1.5"
          rx="0.75"
          transform="translate(5.499 8) rotate(90)"
          fill="currentColor"
        />
        <rect
          id="Rectangle_818"
          data-name="Rectangle 818"
          width="6.965"
          height="1.5"
          rx="0.75"
          transform="translate(11.999 8) rotate(90)"
          fill="currentColor"
        />
        <path
          id="Union_79"
          data-name="Union 79"
          d="M-1683,4835.216a2,2,0,0,1-2-2v-12a2,2,0,0,1,2-2h8.724l1.5,1.5,2.276,2.276,1.5,1.5v.2a.749.749,0,0,1,0,.248v8.279a2,2,0,0,1-2,2Zm-.5-13.5v11a1,1,0,0,0,1,1h11a1,1,0,0,0,1-1v-7.6l-4.4-4.4h-7.6A1,1,0,0,0-1683.5,4821.716Z"
          transform="translate(1684.999 -4819.215)"
          fill="currentColor"
        />
      </>
    ),
  },
  SlackLogo: {
    defaultWidth: '14',
    defaultHeight: '14',
    defaultViewBox: '0 0 14 14',
    defaultColor: iconColors.black,
    data: (
      <>
        <path
          id="Path_15"
          data-name="Path 15"
          d="M5.145,0a1.406,1.406,0,0,0,0,2.812h1.4V1.406A1.406,1.406,0,0,0,5.145,0h0m0,3.749H1.4a1.406,1.406,0,0,0,0,2.812H5.145a1.406,1.406,0,0,0,0-2.812Z"
          transform="translate(0)"
          fill="#36c5f0"
          fillRule="evenodd"
        />
        <path
          id="Path_16"
          data-name="Path 16"
          d="M1311.948,5.155a1.4,1.4,0,1,0-2.807,0V6.562h1.4A1.4,1.4,0,0,0,1311.948,5.155Zm-3.742,0V1.406a1.4,1.4,0,1,0-2.806,0V5.155a1.4,1.4,0,1,0,2.806,0Z"
          transform="translate(-1297.916)"
          fill="#2eb67d"
          fillRule="evenodd"
        />
        <path
          id="Path_17"
          data-name="Path 17"
          d="M1306.7,1314.462a1.406,1.406,0,0,0,0-2.812h-1.4v1.406A1.405,1.405,0,0,0,1306.7,1314.462Zm0-3.75h3.742a1.406,1.406,0,0,0,0-2.812H1306.7a1.406,1.406,0,0,0,0,2.812Z"
          transform="translate(-1297.816 -1300.401)"
          fill="#ecb22e"
          fillRule="evenodd"
        />
        <path
          id="Path_18"
          data-name="Path 18"
          d="M0,1309.406a1.4,1.4,0,1,0,2.807,0V1308H1.4A1.4,1.4,0,0,0,0,1309.406Zm3.742,0v3.75a1.4,1.4,0,1,0,2.806,0v-3.749a1.4,1.4,0,1,0-2.806,0h0"
          transform="translate(0 -1300.501)"
          fill="#e01e5a"
          fillRule="evenodd"
        />
      </>
    ),
  },
  Subtraction: {
    defaultWidth: '324',
    defaultHeight: '324',
    defaultViewBox: '0 0 324 324',
    defaultColor: iconColors.grey_10,
    data: (
      <path
        id="Subtraction_96"
        data-name="Subtraction 96"
        d="M39,4552a163.186,163.186,0,0,1-32.649-3.292,161.226,161.226,0,0,1-30.409-9.439,162.056,162.056,0,0,1-27.518-14.937,162.9,162.9,0,0,1-43.757-43.757,162.034,162.034,0,0,1-14.936-27.518,161.182,161.182,0,0,1-9.439-30.41,163.574,163.574,0,0,1,0-65.3,161.2,161.2,0,0,1,9.439-30.41,162.052,162.052,0,0,1,14.936-27.518,162.915,162.915,0,0,1,43.757-43.757,162.014,162.014,0,0,1,27.518-14.936,161.186,161.186,0,0,1,30.409-9.439,163.568,163.568,0,0,1,65.3,0,161.183,161.183,0,0,1,30.409,9.439,162.022,162.022,0,0,1,27.518,14.936,162.914,162.914,0,0,1,43.757,43.757,162.023,162.023,0,0,1,14.936,27.518,161.2,161.2,0,0,1,9.439,30.41,163.576,163.576,0,0,1,0,65.3,161.2,161.2,0,0,1-9.439,30.41,162.018,162.018,0,0,1-14.936,27.518,162.895,162.895,0,0,1-43.757,43.757,162.064,162.064,0,0,1-27.518,14.937,161.222,161.222,0,0,1-30.409,9.439A163.183,163.183,0,0,1,39,4552Zm0-285a123,123,0,1,0,123,123A123.139,123.139,0,0,0,39,4267Z"
        transform="translate(123 -4228)"
        fill="#d7ecfe"
      />
    ),
  },
  Update: {
    defaultWidth: '16',
    defaultHeight: '14',
    defaultViewBox: '0 0 16 14',
    defaultColor: iconColors.grey_10,
    data: (
      <>
        <path
          id="Union_26"
          data-name="Union 26"
          d="M-1295.027,5214.556c-.012-.019-.024-.037-.035-.057a1,1,0,0,1,.367-1.366,1,1,0,0,1,1.366.366h0A5.021,5.021,0,0,0-1289,5216a5.047,5.047,0,0,0,4.578-3H-1286a1,1,0,0,1-1-1,1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1,1,1,0,0,1-1-1v-1.387a7,7,0,0,1-6,3.388A7.032,7.032,0,0,1-1295.027,5214.556ZM-1296,5211a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1,1,1,0,0,1,1,1v1.4a7.042,7.042,0,0,1,1.3-1.582A6.98,6.98,0,0,1-1289,5204a7.031,7.031,0,0,1,6.034,3.455l.027.044a1,1,0,0,1-.367,1.366,1,1,0,0,1-1.366-.367A5.022,5.022,0,0,0-1289,5206a5.036,5.036,0,0,0-4.581,3H-1292a1,1,0,0,1,1,1,1,1,0,0,1-1,1Z"
          transform="translate(1297 -5204)"
          fill="currentColor"
        />
      </>
    ),
  },
};

export type IconNames = keyof typeof Icons;

interface IconProperties {
  name: IconNames;
  className?: string;
  viewBox?: string;
  style?: React.CSSProperties;
  role?: string;
  width?: string;
  height?: string;
  fill?: string;
  inlineStyle?: boolean;
}

export const Icon: React.FC<IconProperties> = ({
  viewBox,
  width,
  height,
  className,
  name,
  style,
  inlineStyle = true,
  ...props
}) => {
  const icon = Icons[name];
  return (
    <svg
      width={width ?? icon.defaultWidth}
      height={height ?? icon.defaultHeight}
      viewBox={viewBox ?? icon.defaultViewBox}
      style={inlineStyle ? { color: icon.defaultColor, ...style } : {}}
      className={className}
      {...props}
    >
      {icon.data}
    </svg>
  );
};

export default Icon;

export const ButtonIcon = styled(Icon)`
  margin-right: 10px;
  vertical-align: -0.2rem;
`;
